// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Clickable from "@insite/mobius/Clickable/Clickable";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import OverflowMenu from "@insite/mobius/OverflowMenu/OverflowMenu";
import Tag from "@insite/mobius/Tag";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { SectionContainer, SectionTitle } from "@turnerBlueprint/App/Widgets/DesignSystem/DesignSystem.helpers";
import { longText } from "@turnerBlueprint/App/Widgets/DesignSystem/DummyData/DummyData";
import React, { FC } from "react";
import { css } from "styled-components";

interface CommonTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    commonWrapper?: InjectableCss;
}

const commonTabStyles: CommonTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    commonWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
            align-items: flex-start;
        `,
    },
};

const styles = commonTabStyles;
const CommonTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>Spinner</SectionTitle>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <LoadingSpinner />
            </GridItem>
            <GridItem {...styles.gridItem}>
                <SectionTitle>Tags</SectionTitle>
                <StyledWrapper {...styles.commonWrapper}>
                    <Tag deletable={false}>Test Tag</Tag>
                    <Tag onDelete={() => {}}>Test Tag - deletable</Tag>
                    <Tag onDelete={() => {}}>{longText}</Tag>
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <SectionTitle>Overflow menu</SectionTitle>
                <StyledWrapper {...styles.commonWrapper}>
                    <OverflowMenu>
                        <Clickable>{translate("Cancel")}</Clickable>
                        <Clickable>{translate("Send Return Request")}</Clickable>
                    </OverflowMenu>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default CommonTab;
